import { InputSkeleton } from '@/_components';
import { CardContainer, Container, FormLayout, LeftSection, StickyPageHeaderSkeletonWithButtons } from '@/_containers';

export default function Loading() {
  return (
    <>
      <StickyPageHeaderSkeletonWithButtons numberOfButtons={2} />

      <Container>
        <LeftSection>
          <CardContainer>
            <FormLayout>
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
              <InputSkeleton className="col-span-12 sm:col-span-6" />
            </FormLayout>
          </CardContainer>
        </LeftSection>
      </Container>
    </>
  );
}
